import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export type TDeleteCompanyTeamMemberInvitationResponse = {
  readonly deletedCount: number;
};

export const deleteCompanyTeamMemberInvitation = (axios: IAxiosInstance) => {
  return async (options: {
    readonly companyId: string;
    readonly memberUserId: string;
  }) => {
    const { data } = await axios.noRetry.post<
      IApiResponse<TDeleteCompanyTeamMemberInvitationResponse>
    >(`/api/companies/${options.companyId}/team-members/delete-invitation`, {
      memberUserId: options.memberUserId,
    });

    if (data.success) {
      return data.data;
    }

    throw new Error("Failed to delete team invitation");
  };
};
